export default __webpack_public_path__ + "static/media/Poppins-Black.074cc2c3.eot";